'use client';

import { useEffect } from 'react';
import {AI_EMBED_BASE} from "@/app/components/atomic/molecules/AIToolEmbed";

interface AIToolProps {
    toolFileName: string;
    children?: React.ReactNode;
}

const AITool: React.FC<AIToolProps> = ({ toolFileName, children }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `${AI_EMBED_BASE}${toolFileName}.js`;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [toolFileName]);

    return (
        <div
            className="ai-tool-container"
            id={toolFileName}
        >
            {children}
        </div>
    );
};

export default AITool;
